var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic_wrap"},[_c('iframe',{staticClass:"external-link",attrs:{"src":"https://chat.cre-energy.cc/","frameborder":"0","allowfullscreen":"","scrolling":"yes"}})])
}]

export { render, staticRenderFns }